import ReactModal from "react-modal";
import { useModal } from "react-modal-hook";

export default () => {
  return { useModalComponent: useModal, Modal: ReactModal };
};
